import { Sparkles, Network as NetworkIcon } from "lucide-react";
import { useHostNetworks, usePruneNetworks } from "@/hooks/useDocker";

export function NetworksPanel({ hostId }: { hostId: number }) {
  const { data: networks, isLoading } = useHostNetworks(hostId);
  const prune = usePruneNetworks(hostId);

  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between gap-2">
        <h2 className="text-lg font-semibold text-gray-200">Networks</h2>
        <button
          onClick={() => {
            if (window.confirm("Supprimer les réseaux non utilisés ?"))
              prune.mutate();
          }}
          className="inline-flex items-center gap-1 rounded border border-gray-700 px-3 py-1 text-sm text-gray-300 hover:bg-gray-800"
        >
          <Sparkles className="h-3.5 w-3.5" />
          Prune
        </button>
      </div>

      <div className="space-y-2">
        {(networks ?? []).map((n) => (
          <div
            key={n.id}
            className="rounded-lg border border-gray-800 p-3"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <NetworkIcon className="h-4 w-4 text-gray-500" />
                <span className="font-mono text-sm text-gray-100">
                  {n.name}
                </span>
                <span className="rounded bg-gray-800 px-2 py-0.5 text-xs text-gray-400">
                  {n.driver}
                </span>
                {n.internal && (
                  <span className="rounded bg-yellow-900/40 px-2 py-0.5 text-xs text-yellow-300">
                    internal
                  </span>
                )}
              </div>
              <span className="text-xs text-gray-500">
                {n.containers.length} conteneur
                {n.containers.length > 1 ? "s" : ""}
              </span>
            </div>
            {n.containers.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1.5">
                {n.containers.map((c) => (
                  <span
                    key={c.id}
                    title={c.ipv4 ?? ""}
                    className="rounded bg-gray-900 px-2 py-0.5 font-mono text-xs text-gray-400"
                  >
                    {c.name}
                    {c.ipv4 ? ` · ${c.ipv4.split("/")[0]}` : ""}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
        {!isLoading && networks && networks.length === 0 && (
          <p className="text-gray-500">Aucun réseau.</p>
        )}
      </div>
    </section>
  );
}
